"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setCurrentPage = exports.setActivitiesLoaded = exports.removeActivityFromEntities = exports.getNewPageOfActivities = exports.editActivity = exports.disableInfiniteActivityIndicator = exports.deleteActivity = exports.default = exports.createNewActivity = void 0;
var _types = require("./types");
var createNewActivity = content => ({
  type: _types.CREATE_NEW_ACTIVITY,
  content
});
exports.createNewActivity = createNewActivity;
var deleteActivity = _activity => ({
  type: _types.DELETE_ACTIVITY,
  _activity
});
exports.deleteActivity = deleteActivity;
var disableInfiniteActivityIndicator = () => ({
  type: _types.DISABLE_INFINITE_ACTIVITY_INDICATOR
});
exports.disableInfiniteActivityIndicator = disableInfiniteActivityIndicator;
var editActivity = (_activity, content) => ({
  type: _types.EDIT_ACTIVITY,
  _activity,
  content
});
exports.editActivity = editActivity;
var getNewPageOfActivities = () => ({
  type: _types.GET_NEW_PAGE_OF_ACTIVITIES
});
exports.getNewPageOfActivities = getNewPageOfActivities;
var removeActivityFromEntities = _activity => ({
  type: _types.REMOVE_ACTIVITY_FROM_ENTITIES,
  _activity
});
exports.removeActivityFromEntities = removeActivityFromEntities;
var setActivitiesLoaded = loaded => ({
  type: _types.SET_ACTIVITIES_LOADED,
  loaded
});
exports.setActivitiesLoaded = setActivitiesLoaded;
var setCurrentPage = currentPage => ({
  type: _types.SET_CURRENT_PAGE,
  currentPage
});
exports.setCurrentPage = setCurrentPage;
var _default = exports.default = {
  createNewActivity,
  deleteActivity,
  disableInfiniteActivityIndicator,
  editActivity,
  getNewPageOfActivities,
  removeActivityFromEntities,
  setActivitiesLoaded,
  setCurrentPage
};